export default __webpack_public_path__ + "static/media/download.f917d37b.png";